import { PREVIEW_LINK_PREFIX } from '../../../../../packages/site-renderer/src/render-core.mjs';

export type CmsPreviewLinkAction =
  | { kind: 'page'; slug: string; fragment: string | null }
  | { kind: 'fragment'; fragment: string }
  | { kind: 'document' }
  | { kind: 'external' }
  | { kind: 'unavailable' }
  | { kind: 'disabled' };

/** A pure, bounded resolver: preview clicks never navigate the iframe or Admin. */
export function cmsPreviewLinkAction(href: string, pageSlugs: readonly string[]): CmsPreviewLinkAction {
  if (!href.startsWith(PREVIEW_LINK_PREFIX)) return { kind: 'disabled' };
  let value: string;
  try {
    value = decodeURIComponent(href.slice(PREVIEW_LINK_PREFIX.length));
  } catch {
    return { kind: 'disabled' };
  }
  if (/^#[a-z][a-z0-9_-]{0,63}$/i.test(value)) {
    return { kind: 'fragment', fragment: value.slice(1) };
  }
  if (/^https:\/\/[^\s]+$/i.test(value)) return { kind: 'external' };
  if (!value.startsWith('/') || value.startsWith('//') || value.includes('\\')) return { kind: 'disabled' };
  const rawPath = value.split(/[?#]/, 1)[0];
  if (rawPath.includes('%') || rawPath.split('/').some(segment => segment === '..' || segment === '.'))
    return { kind: 'disabled' };
  let url: URL;
  try {
    url = new URL(value, 'https://cms-preview.invalid');
  } catch {
    return { kind: 'disabled' };
  }
  if (url.origin !== 'https://cms-preview.invalid') return { kind: 'disabled' };
  if (/^\/documents\/[a-z0-9-]+\.pdf$/.test(url.pathname)) return { kind: 'document' };
  const match = /^\/([a-z0-9](?:[a-z0-9-]{0,62}[a-z0-9])?)\/?$/.exec(url.pathname);
  const slug = url.pathname === '/' ? 'home' : match?.[1];
  if (!slug || !pageSlugs.includes(slug)) return { kind: 'unavailable' };
  return {
    kind: 'page',
    slug,
    fragment: /^[a-z][a-z0-9_-]{0,63}$/i.test(url.hash.slice(1)) ? url.hash.slice(1) : null,
  };
}
